import React from 'react';
import StatusDot from '../../../components/status/StatusDot';
import { clientAgents } from '../../../mocks/client';

/**
 * Read-only agent roster (T9.5). Clients see what each agent does and its
 * status — never controls. Any change desire routes through "Request a change"
 * (no-config guarantee, T9.10).
 */
function ClientAgentList({ onRequestChange }) {
  return (
    <section className="portal-card">
      <div className="portal-card-head">
        <div>
          <h2>Your agent team</h2>
          <span>Managed for you by the agency</span>
        </div>
        <button className="portal-link-button" onClick={onRequestChange} type="button">
          Request a change
        </button>
      </div>
      <ul className="portal-agent-list">
        {clientAgents.map((agent) => (
          <li key={agent.id}>
            <div className="portal-agent-avatar" aria-hidden="true">{agent.name.slice(0, 2)}</div>
            <div>
              <strong>{agent.name}</strong>
              <p>{agent.summary}</p>
            </div>
            <div className="portal-agent-status">
              <StatusDot status={agent.status} />
              <span>{agent.status}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default ClientAgentList;
